import React, { useState, useEffect } from "react";
import { Scroll } from "../Scroll function/scroll";
import { ToggleMenu } from "./UserProfile";
import { BackToscreen } from "./Orders";
import { FaArrowLeft, FaEye } from "react-icons/fa";
import "./help_and_support.css";
import "./Myprescription.css";
import { AiOutlineDownload } from "react-icons/ai";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import { prescriptionDataAction } from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../Loader/Loader";
import moment from "moment";
import { Modal } from "react-responsive-modal";
import { image } from "html2canvas/dist/types/css/types/image";
import file_size_url from 'file_size_url';
 
function isMyPrescription() {
  const dispatch = useDispatch();
  const [PdftoView, setPdftoView] = useState("");
  const [updateDate, setUpdateDate] = useState("");
  const prescriptionData = useSelector(
    (state) => state.getPrescriptionDataReducer
  );
  const { loading, PrescriptionDetails } = prescriptionData;

  // const size = file_size_url(PdftoView).catch((error) => console.log(error));

  // console.log(size, "<<<<<< size");

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  console.log(PdftoView, "<<<< file");
  useEffect(() => {
    Scroll();

    if (localStorage.getItem("user")) {
      const datekey = JSON.parse(localStorage.getItem("user"));
      const token = datekey && datekey?.token;
      token !== undefined && token !== ""
        ? dispatch(prescriptionDataAction(token))
        : null;
    } else {
      console.log("no user");
    }
  }, []);

  return (
    <div>
      <NewHeader />

      <div className="activeDashboard">
        <div className="dashboard_content">
          <div className="back_btn">
            {/* <Link to="/userdashboard">
              <FaArrowLeft /> Back to dashboard
            </Link> */}
          </div>
          <BackToscreen title="My Prescription" />

          <div className="flexparent">
            <div className="dashboard_contentLeft">
              <ToggleMenu isMyPrescription={true} />
            </div>

            <div className="dashboard_contentRight dashboard_contentRight2">
              <div className="dashboard_contentRight_contentBox ">
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    {PrescriptionDetails &&
                      PrescriptionDetails?.results &&
                      PrescriptionDetails?.results.map((item) => {
                        if (item?.image && item?.image != "") {
                          return (
                            <>
                              <div className="prescriptionBox" key={item?.id}>
                                <div className="d_flex_justifyBetween">
                                  <div className="prescriptionBox_left">
                                    <span>{item?.name}</span>
                                    <span>PDF</span>
                                  </div>
                                  <div className="prescriptionBox_right">
                                    <span
                                      className="IconBoc"
                                      onClick={() => {
                                        setPdftoView(item?.image);
                                        setUpdateDate(item?.updated_at);
                                        setTimeout(() => {
                                          onOpenModal();
                                        }, 200);
                                      }}
                                    >
                                      <FaEye />
                                    </span>
                                    <a
                                      href={item?.image}
                                      target="_blank"
                                      download
                                    >
                                      <span className="IconBoc">
                                        <AiOutlineDownload />
                                      </span>
                                    </a>
                                  </div>
                                </div>

                                <p
                                  className="text_grey"
                                  style={{
                                    width: "97%",
                                    margin: "0.5rem 0rem",
                                    fontSize: "1.5rem",
                                  }}
                                >
                                  Last Updated on :{" "}
                                  {moment(item?.updated_at).format(
                                    "DD/MM/YYYY"
                                  )}
                                </p>
                              </div>
                            </>
                          );
                        }
                      })}
                  </>
                )}

                {/* <div className="prescriptionBox">
                  <div className="d_flex_justifyBetween">
                    <div className="prescriptionBox_left">
                      <span>Prescription 1</span>
                      <span>PDF</span>
                    </div>
                    <div className="prescriptionBox_right">
                      <span className="IconBoc">
                        <FaEye />
                      </span>
                      <span className="IconBoc">
                        <AiOutlineDownload />
                      </span>
                    </div>
                  </div>

                  <p className="text_grey" style={{width:"97%",margin:"0.5rem 0rem",fontSize:"1.5rem"}}>Last Updated on : 17/01/20222</p>
                </div> */}
              </div>

              <div className="divupload">
                <Link to="/uploadprescription">
                  <button className="uploadButton" style={{textTransform: "none"}}>Upload Prescription</button>
                </Link>
              </div>

              {/* <h1 className="faqs">FAQs</h1>
              <div className="dashboard_contentRight-contentBox lowerContent">
                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>

                  <div className="lowerContent_text">
                      <p><strong>Who all are eligible for the test?</strong></p>
                      <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy psum</p>
                  </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="popupModalContainer">
        <Modal open={open} onClose={onCloseModal} center 
        classNames={{
          modal: 'footerPopModal',
        }}>
          <div className="modalContent">
            <iframe src={PdftoView} className="prescripIframe"></iframe>
            <div className="popupFooter">
              <div className="leftSideF">
                <span>Format : {PdftoView && PdftoView.split(".")[PdftoView.split(".").length -1]}</span>
                {/* <span>Size : 500KB</span> need to make it dynamic */}
              </div>
              <div className="rightSideF">
                {/* <button>Download</button> */}
                <span>Date : {moment(updateDate).format('DD/MM/YYYY')}</span>
              </div>
            </div>
          </div>
        </Modal>
      </div>
      <Footer />
    </div>
  );
}

export default {
  component: isMyPrescription,
};
